import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { LoanFeesTypesState } from "../../../../utils/types";

export const pending = (state: LoanFeesTypesState) => {
  state.isLoading = true;
  state.isError = false;
  state.data = null;
};

export const fulfilled = (
  state: LoanFeesTypesState,
  action: PayloadAction<
    Types.ApiResponse<Types.LoanFeesTypes.GetLoanFeesTypesResponse[]>
  >
) => {
  state.isLoading = false;
  state.isError = false;
  state.isSuccess = action.payload.success;
  state.data = action.payload.response;
};

export const rejected = (state: LoanFeesTypesState) => {
  state.isLoading = false;
  state.isError = true;
  state.isSuccess = false;
};
